export interface QtdEmployeesOption {
  value: number;
  label: string;
}

export const QtdEmployeesOptions: QtdEmployeesOption[] = [
  {
    value: 1,
    label: 'até 9',
  },
  {
    value: 2,
    label: '10- 49',
  },
  {
    value: 3,
    label: '50 – 99',
  },
  {
    value: 4,
    label: 'Mais de 100',
  },
];
